<template>
  <div class="w-100">
    <div class="row mx-0">
      <div class="col-12">
        <div class="feedback-header">
          <p class="ml-0" v-if="currentOption && currentOption.thanks_page_title">{{ currentOption.thanks_page_title }}</p>
        </div>
      </div>
    </div>
    <div class="row mt-3 mx-0" v-if="currentOption && currentOption.show_message == 1">
      <div class="col-12">
        <div class="intro-msg" v-bind:style="{ background: setting.message_background_color }">
          <p class="mb-0" v-bind:style="{ color: setting.message_text_color }" v-html="currentOption.personalized_message"></p>
        </div>
      </div>
    </div>
    <userProfile v-if="currentOption && currentOption.show_profile_card == 1"></userProfile>
    <div class="row mt-3 mx-0 reward-wraper">
      <div class="col-12 reward" v-if="currentOption && currentOption.reward_settings">
        <div class="d-flex align-items-center justify-content-between">
          <div class="reward-head d-flex align-items-center">
            <img src="../assets/confetti.svg" width="16" alt="" />
            <p>Reward:</p>
          </div>
          <a href="#" data-toggle="modal" :reward_detail="currentOption && currentOption.reward_settings.reward_detail ? currentOption.reward_settings.reward_detail : ''" data-target="#exampleModal" class="reward-detail d-flex align-items-center">
            <p>Details</p>
            <img src="../assets/info-icon-primary.svg" width="16" alt="" />
          </a>
        </div>
        <h5 class="reward-title" v-if="currentOption">
          {{ currentOption.reward_settings.reward_title }}
        </h5>
      </div>
      <div class="reward-message">
        <p v-if="!already_take_reward && currentOption && currentOption.reward_settings && currentOption.reward_settings.reward_approval == 1" v-html="currentOption.reward_settings.reward_redemption"></p>
        <p v-if="!already_take_reward && currentOption && currentOption.reward_settings && currentOption.reward_settings.reward_approval == 2">
          After your submission is approved, your reward will be released to your contact information input on the previous page.
        </p>
        <p v-if="already_take_reward" class="limited_reward_message">
          Rewards are limited to 1 per person. Our records show you have already claimed a reward.
        </p>
      </div>
      <a class="btn action-btn mt-3" target="_blank" :href="currentOption && currentOption.call_to_action_btn_link" v-if="currentOption && currentOption.show_call_action_btn == 1"> <img src="../assets/arrow-right.svg" class="icon" alt="" /> {{ currentOption.call_to_action_btn_title }} </a>
    </div>
    <a class="back-btn btn-link d-flex align-items-center mt-3" style="padding-left: 15px" @click="reset">
      <div class="icon">
        <img src="../assets/angle-left.svg" alt="" />
      </div>
      <div class="text">
        <p class="mb-0">Back to home</p>
      </div>
    </a>
    <div class="d-flex align-items-center justify-content-center mt-3">
      <branding></branding>
    </div>

    <div class="modal fade" id="exampleModal" tabindex="-1" data-backdrop="static" aria-labelledby="exampleModalLabel" aria-hidden="true">
      <div class="modal-dialog modal-dialog-centered reward-modal">
        <div class="modal-content">
          <div class="modal-body">
            <button type="button" class="close" data-dismiss="modal" aria-label="Close">
              <span aria-hidden="true">&times;</span>
            </button>
            <h5 class="modal-title">Reward Details</h5>
            <p class="modal-desc" v-if="currentOption && currentOption.reward_settings" v-html="currentOption.reward_settings.reward_detail"></p>
            <!-- <a href="https://www.acme.com/reward-3824" class="link"
              >https://www.acme.com/reward-3824</a
            > -->
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import userProfile from "./partials/userProfile.vue";
// import UserPeronalizedMessage from "./partials/UserPeronalizedMessage.vue";
import Branding from "./partials/branding.vue";

export default {
  components: { userProfile, Branding },
  name: "CustomAudioRecorder",
  props: ["audioSrc", "audioFile", "already_take_reward"],
  data() {
    return {
      currentOption: {},
    };
  },
  created() {
    this.setting = this.$session.get("response").settings;
    this.currentOption = this.$session.get("currentOption");
  },
  methods: {
    reset() {
      this.$router.push({ name: "Home" });
    },
  },
  mounted() {
    window.addEventListener(
      "message",
      (event) => {
        if (event.origin === "http://localhost:8100" || event.origin === "https://vkstg.larkbase.com" || event.origin === "https://app.vouchkick.com") {
          if (event.data.option) {
            this.response = this.$session.get("response");
            if (this.response.options.length) {
              this.response.options.forEach((element) => {
                if (element.feedback_option_id == this.currentOption.feedback_option_id) {
                  this.currentOption = element;
                  this.$session.set("currentOption", this.currentOption);
                }
              });
            }
          }
        }
      },
      false
    );
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
.intro-msg {
  padding: 8px 16px;
  background: #2aa6ff;
  border-radius: 15px 15px 15px 0px;
  p {
    font-family: "Mulish", sans-serif;
    font-style: normal;
    font-weight: 600;
    font-size: 14px;
    line-height: 18px;
    color: #ffffff;
    text-align: left;
  }
}
.reward-wraper {
  padding-left: 15px;
  padding-right: 15px;
}
.limited_reward_message {
  color: #ff3d00 !important;
}
.reward-message {
  background: #ffffff;
  border-radius: 0px 0px 5px 5px;
  width: 100%;
  p {
    font-family: Poppins;
    font-style: normal;
    font-weight: 500;
    font-size: 13px;
    line-height: 20px;
    /* or 154% */

    letter-spacing: 0.01em;

    /* Dark / Divider */

    color: #313c4e;
    padding: 20px 10px 22px 10px;
    text-align: left;
    span {
      color: #ff0061;
    }
  }
}
.action-btn {
  display: flex;
  align-items: center;
  justify-content: center;
  background: var(--accent-color);
  border-radius: 4px;
  color: var(--action-btn-color);
  max-width: 380px;
  width: 100%;
  padding-bottom: 5px;
  padding-top: 5px;
  box-shadow: 0px 2px 4px 0px rgba(0, 0, 0, 0.24);
  font-family: "Poppins", sans-serif;
  font-size: 15px;
  font-weight: 500;
  line-height: 24px;
  letter-spacing: 0.01em;
  height: 50px;

  .icon {
    margin-right: 8px;
  }

  p {
    font-family: "Poppins", sans-serif;
    font-style: normal;
    font-weight: 500;
    font-size: 15px;
    line-height: 24px;
    letter-spacing: 0.01em;
  }
}
.reward {
  background: #ffffff;
  box-shadow: 0px 2px 12px rgba(0, 0, 0, 0.1);
  border-radius: 4px 4px 0px 0px;
  padding: 10px 15px 10px 10px;
  .reward-head {
    p {
      font-family: "Poppins", sans-serif;
      font-style: normal;
      font-weight: 500;
      font-size: 13px;
      line-height: 20px;
      color: #56657f;
      margin: 0;
      margin-left: 4px;
    }
  }
  .reward-detail {
    p {
      font-family: "Poppins", sans-serif;
      font-style: normal;
      font-weight: 500;
      font-size: 11px;
      line-height: 16px;
      color: var(--accent-color);
      margin: 0;
      margin-right: 4px;
    }
  }
  .reward-title {
    font-family: "Poppins", sans-serif;
    font-style: normal;
    font-weight: 500;
    font-size: 14px;
    line-height: 24px;
    letter-spacing: 0.01em;
    color: #313c4e;
    text-align: left;
    margin: 10px 0px;
  }
  .remaining-reward {
    .badge {
      background: var(--accent-color);
      border-radius: 10px;
      padding: 0px 10px;
      font-family: "Poppins", sans-serif;
      font-style: normal;
      font-weight: 500;
      font-size: 12px;
      line-height: 18px;
      text-align: left;
      letter-spacing: 0.01em;
      color: white;
      margin-right: 10px;
    }
    p {
      font-family: "Poppins", sans-serif;
      font-style: normal;
      font-weight: 500;
      font-size: 13px;
      line-height: 20px;
      letter-spacing: 0.01em;
      color: #2b3648;
    }
  }
}
.reward-modal {
  .modal-body {
    padding: 32px;
    position: relative;
    text-align: left;

    .close {
      position: absolute;
      top: 18px;
      right: 15px;
    }

    .modal-title {
      font-family: "Poppins", sans-serif;
      font-style: normal;
      font-weight: 600;
      font-size: 16px;
      line-height: 24px;
      letter-spacing: 0.01em;
      color: #313c4e;
      margin-bottom: 18px;
    }

    .modal-desc {
      font-family: "Poppins", sans-serif;
      font-style: normal;
      font-weight: 500;
      font-size: 13px;
      line-height: 20px;
      letter-spacing: 0.01em;
      color: #313c4e;
      margin: 0;
    }

    .link {
      color: var(--accent-color);
    }
  }
}
</style>
